import { render, staticRenderFns } from "./RIDListView.vue?vue&type=template&id=0f1dd817&scoped=true"
import script from "./RIDListView.vue?vue&type=script&lang=js"
export * from "./RIDListView.vue?vue&type=script&lang=js"
import style0 from "./RIDListView.vue?vue&type=style&index=0&id=0f1dd817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1dd817",
  null
  
)

export default component.exports